import { useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import AppLayout from './AppLayout'
import LoadingSpinner from './ui/LoadingSpinner'

interface AppLayoutWrapperProps {
  children: React.ReactNode
}

export default function AppLayoutWrapper({ children }: AppLayoutWrapperProps) {
  const location = useLocation()
  const { user, loading } = useAuth()

  console.log('📱 AppLayoutWrapper: Rendering', { pathname: location.pathname, loading, hasUser: !!user })

  // Pages that should not show the sidebar
  const noSidebarPages = ['/login', '/reset-password', '/update-password']
  const isPublicPage = noSidebarPages.includes(location.pathname)

  console.log('📱 AppLayoutWrapper: Route check', { isPublicPage, pathname: location.pathname })

  // For public pages, show content immediately without waiting for auth
  if (isPublicPage) {
    console.log('📱 AppLayoutWrapper: Rendering public page without sidebar')
    return (
      <div className="min-h-screen bg-gray-50">
        {children}
      </div>
    )
  }

  // Show loading spinner while auth is loading for protected pages
  if (loading) {
    console.log('📱 AppLayoutWrapper: Showing loading spinner (auth loading)')
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingSpinner />
      </div>
    )
  }

  // Show sidebar only for authenticated users and not on auth pages
  if (user && !noSidebarPages.includes(location.pathname)) {
    console.log('📱 AppLayoutWrapper: Rendering with AppLayout (authenticated)')
    return <AppLayout>{children}</AppLayout>
  }

  // For unauthenticated users or auth pages, show children without sidebar
  console.log('📱 AppLayoutWrapper: Rendering without sidebar (unauthenticated)')
  return (
    <div className="min-h-screen bg-gray-50">
      {children}
    </div>
  )
}
